export const AndarBahar = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
    >
        <path
            className="ico_pri"
            d="M34.523 36.302c.6-.39 1.065-.994 1.264-1.74l5.57-20.787a3 3 0 0 0-2.121-3.674L26.553 6.703a2.993 2.993 0 0 0-2.48.428c-.563.39-.996.975-1.183 1.689l-.06.23c.33.04.65.13.97.24a5.067 5.067 0 0 1 .89.41l.021.015.1-.373a1 1 0 0 1 1.225-.707l12.682 3.398a1 1 0 0 1 .707 1.225l-5.57 20.787a1 1 0 0 1-1.145.724c-.002.33-.032.65-.09.971-.07.33-.16.65-.29.95.19.04.39.08.58.08a3.091 3.091 0 0 0 1.614-.468Z"
        />
        <path
            className="ico_pri"
            d="M30.741 26.706c.427-.192.785-.342.989-.426.78-.26 1.42-.9 1.64-1.77a2.51 2.51 0 0 0-1.76-3.01v-.01a2.508 2.508 0 0 0-2.158.407l1.29 4.809Zm-2.481-9.258.23.062-.26-6.07-1.37-.37-.327.513a5 5 0 0 1 .441 1.07l.313-.49.096 2.015.877 3.27Z"
        />
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M9.216 16.438a1 1 0 0 0-.707 1.225l5.57 20.787a1 1 0 0 0 1.224.707l12.683-3.398a1 1 0 0 0 .707-1.225l-5.57-20.787a1 1 0 0 0-1.225-.707L9.216 16.438Zm-2.64 1.743a3 3 0 0 1 2.122-3.675l12.683-3.398a3 3 0 0 1 3.674 2.121l5.57 20.787a3 3 0 0 1-2.122 3.674l-12.682 3.4a3 3 0 0 1-3.674-2.122l-5.57-20.786Z"
            clipRule="evenodd"
        />
        <path
            className="ico_pri"
            d="M18.03 24.63c-.55 2.5-1.79 4.43-2.19 5.02-.07.1-.04.24.07.3 2.07 1.25 3.85 2.9 4.5 3.57.12.13.34.07.38-.1.23-.91.89-3.2 2.04-5.31.06-.11.02-.26-.09-.31-.64-.32-2.61-1.38-4.33-3.28a.225.225 0 0 0-.39.1l.01.01Zm-7.15-.43.26-6.07 1.37-.37 3.26 5.12-.96.26-2.95-4.59.21-.06-.24 5.44-.96.26.01.01Zm.66-1.47-.23-.88 2.94-.79.23.88-2.94.79Z"
        />
    </svg>
);
